<template>
  <div class="address-history-container" ref="mainContainer">
    <!-- 关键：ref移到最外层可滚动容器 -->
    <Header :title="title" />
    <div v-if="datas.status" class="address-container">
      <div
        class="empty-container"
        v-if="datas.data.data.length < 1 && !isLoading"
      >
        <Empty text="还没有晚报历年订阅地址"></Empty>
      </div>
      <div class="address-list-container" v-else>
        <div
          class="address-items"
          v-for="(item, index) in datas.data.data"
          :key="item.number || index"
        >
          <el-descriptions
            class="margin-top"
            :title="`卡号:${item.number}投递详情`"
            :column="2"
            size="default"
            direction="vertical"
            :border="true"
          >
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">联系人</div>
              </template>
              {{ item.username }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">联系电话</div>
              </template>
              {{ item.phone }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">投递地址</div>
              </template>
              {{ item.location }}{{ item.address }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div
          class="loading"
          element-loading-text="加载中..."
          v-loading="isLoading"
          v-if="!isNotMore"
        ></div>
        <div class="noMore" v-if="isNotMore">已加载历年全部订阅地址</div>
      </div>
      <div class="userinfo-btn">
        <el-button type="danger" @click="goDyWebview" class="dingyue-container">
          即刻激活订阅
        </el-button>
      </div>
    </div>
    <div class="empty-container" v-else>
      <Empty text="请先微信授权"></Empty>
    </div>
  </div>
</template>

<script>
import fetchData from "@/mixins/fetchData.js";
import { getMyAddresslist } from "@/api/user.js";
import mainScroll from "@/mixins/mainScroll.js";
import Header from "@/components/util/Header";
import Empty from "@/components/Empty";

export default {
  name: "AddressHistory",
  components: {
    Header,
    Empty,
  },
  data() {
    return {
      title: "晚报历年订阅地址",
      storage: window.localStorage,
      page: 1,
      limit: 10,
      isLoading: false, // 关键：补充缺失的isLoading状态
      isNotMore: false,
    };
  },
  mixins: [
    fetchData({ data: { data: [], total: 0 } }),
    mainScroll("mainContainer"),
  ],
  created() {
    this.$bus.$on("mainScroll", this.handleScroll);
    // 初始化加载数据（关键：页面加载时主动请求第一页）
    this.initFetch();
  },
  unmounted() {
    this.$bus.$off("mainScroll", this.handleScroll);
  },
  methods: {
    // 初始化加载（新增）
    async initFetch() {
      this.isLoading = true;
      try {
        const res = await this.fetchData();
        this.datas = res; // 初始化赋值
        this.isNotMore = !this.hasMore; // 初始判断是否有更多
      } catch (error) {
        console.error("初始化加载地址失败：", error);
        this.datas = { status: true, data: { data: [], total: 0 } };
        this.isNotMore = true;
      } finally {
        this.isLoading = false;
      }
    },

    async fetchData() {
      // 容错：如果没有uid/token，直接返回空数据
      const uid = this.storage.getItem("uid");
      const usertoken = this.storage.getItem("usertoken");
      if (!uid || !usertoken) {
        console.warn("缺少uid或usertoken，无法加载地址数据");
        return { status: true, data: { data: [], total: 0 } };
      }

      try {
        const res = await getMyAddresslist(
          uid,
          usertoken,
          this.page,
          this.limit
        );
        return {
          ...res,
          data: res.data || { data: [], total: 0 },
        };
      } catch (error) {
        console.error("请求地址接口失败：", error);
        return { status: true, data: { data: [], total: 0 } };
      }
    },

    handleScroll(dom) {
      // 增加调试日志，定位问题
      console.log("触发滚动监听：", {
        dom: !!dom,
        isLoading: this.isLoading,
        isNotMore: this.isNotMore,
        scrollTop: dom.scrollTop,
        clientHeight: dom.clientHeight,
        scrollHeight: dom.scrollHeight,
        dec: dom
          ? Math.abs(dom.scrollTop + dom.clientHeight - dom.scrollHeight)
          : "无DOM",
      });

      if (this.isLoading || !dom || this.isNotMore) {
        return;
      }

      const range = 20;
      const dec = Math.abs(dom.scrollTop + dom.clientHeight - dom.scrollHeight);
      if (dec <= range) {
        this.fetchMore();
      }
    },

    async fetchMore() {
      console.log("触发加载更多：", { hasMore: this.hasMore, page: this.page });
      if (!this.hasMore) {
        this.isNotMore = true;
        return;
      }
      this.isLoading = true;
      this.page++;

      try {
        const resp = await this.fetchData();
        // 合并数据（容错：防止resp.data.data为undefined）
        const newData = resp.data.data || [];
        this.datas.data.total = resp.data.total || this.datas.data.total;
        this.datas.data.data = this.datas.data.data.concat(newData);
        // 更新无更多状态
        this.isNotMore = !this.hasMore;
      } catch (error) {
        console.error("加载更多地址失败：", error);
        this.page--; // 页码回退
      } finally {
        this.isLoading = false;
      }
    },

    goDyWebview() {
      const url = `https://sale.xinmin.cn/wanbaodingyue/index.html?accesstoken=${encodeURIComponent(
        this.storage.getItem("usertoken") || ""
      )}`;
      window.open(url, "_blank");
    },
  },
  computed: {
    hasMore() {
      const currentLen = this.datas.data.data.length || 0;
      const total = this.datas.data.total || 0;
      console.log("判断是否有更多：", {
        currentLen,
        total,
        result: currentLen < total,
      });
      return currentLen < total;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";
.address-history-container .header-wrap {
  background-color: var(--f56c6c);
  color: var(--fff);
}

// 关键：设置外层容器为全屏可滚动
.address-history-container {
  padding-top: 70px;
  width: 100%;
  height: 100vh; // 全屏高度
  overflow-y: auto; // 开启垂直滚动
  scroll-behavior: smooth;
}

.address-container {
  width: 96%;
  padding-bottom: calc(60px + env(safe-area-inset-bottom)); // 预留按钮高度
  margin: auto;
}

.address-list-container {
  width: 100%;
}

.address-items {
  margin-top: 16px;
}

.address-items:first-child {
  margin-top: 0;
}

.empty-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 100px); // 适配空状态高度
}

.userinfo-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #fff;
  padding: 10px 0 calc(10px + env(safe-area-inset-bottom));
  z-index: 100;
}

.dingyue-container {
  margin: auto;
  width: 60%;
}

.loading {
  background: transparent;
  margin: 20px 0;
  height: 20px;
  text-align: center;
}

.noMore {
  color: var(--ccc);
  margin: 20px 0;
  height: 20px;
  font-size: 14px;
  text-align: center;
}
</style>